import { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";

import { api } from "./pureFunctions"

import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import { de } from "date-fns/locale/de";
import Karte from "./Karte";
import { getStaticData, parseOODate } from "./pureFunctions";
import { getAppointmentsWithLocations } from "./networkFunctions";
registerLocale("de", de);

const myColumns = {};

const calenderInterval = ["-", 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];
const terminArten = {
   "Einkaufstermin neu": { kuerzel: "ET neu" },
   "Einkaufstermin Übergabe Bewertungsmappe": {
      kuerzel: "ET BM-Ü",
   },
   /* Besichtigung: { kuerzel: "BS" },
   "Besichtigung bestätigt": { kuerzel: "BS best" },
   Notartermin: { kuerzel: "NT" }, */
};


export default function Einkaufsterminkarte({ }) {
   const [selectedTermin, setSelectedTermin] = useState("");
   const [startDatum, setStartDatum] = useState(new Date());
   const [endDatum, setEndDatum] = useState(() => {
      const newDatum = new Date(new Date().getTime() + 14 * 24 * 60 * 60 * 1000);
      return newDatum;
   });
   const [calenderday, setCalenderday] = useState(new Date());
   const [alleFilter, setAlleFilter] = useState(true);
   const [userObjects, setUserObjects] = useState();
   const [availableUsers, setAvailableUsers] = useState();
   const [benutzerOptionen, setBenutzerOptionen] = useState();

   const [einkaufstermine, setEinkaufstermine] = useState([]);
   const [alleTermine, setAlleTermine] = useState([]);
   const [dayTermine, setDayTermine] = useState([]);
   const [dayTermine2, setDayTermine2] = useState([]);
   const [showAlleTage, setShowAlleTage] = useState(true);

   async function getEinkaufstermine(datespan) {
      let timeLimit=[]

         timeLimit=parseOODate(startDatum,endDatum)

      let parameters = {
         data: ["id", "type", "subject", "status", "date", "location", "users", "contacts", "estate"],
         filter: {
            startDate: timeLimit[0],
            endDate: timeLimit[1],
            // isDone: false,
            isCancelled: false,
            type: [{ op: "IN", val: Object.keys(terminArten) }],
         },
         listlimit: 500,
         listoffset: 0,
      };
      if (benutzerOptionen && Object.keys(benutzerOptionen).length) {
         parameters.filter.userIds = Object.keys(benutzerOptionen).map((item) => item);
      }
      console.log(parameters);

      let [terminResponse, fullDataTermin, newAvailableUsers] = await getAppointmentsWithLocations(parameters);

      setAlleTermine(terminResponse);
      setAvailableUsers(newAvailableUsers);
      setEinkaufstermine(fullDataTermin);
   }

   async function getBasicData() {
      let [newestatekacheln, cleanUserData, newfieldConfiguration] = await getStaticData();
      setUserObjects(cleanUserData.userObject);
   }

   useEffect(() => {
      getEinkaufstermine();
      getBasicData();
   }, []);

   useEffect(() => {
      const newDayTermine2 = alleTermine
         .filter((item) => new Date(item.elements.date.start).toLocaleDateString() === calenderday.toLocaleDateString())
         .reduce(
            (oldObj, item) => ({
               ...oldObj,
               [item.elements.users[0].id]: oldObj[item.elements.users[0].id]
                  ? [...oldObj[item.elements.users[0].id], {...item.elements, terminId: item.terminId} ]
                  : [{...item.elements, terminId: item.terminId}],
            }),
            {}
         );
         console.log(alleTermine);
         console.log(newDayTermine2);
         
         

      setDayTermine2(newDayTermine2);
      // setDayTermine(newDayTermine);
   }, [calenderday, alleTermine]);

   return (
      <>
         <div className="m-5 mt-4">
            <title>Karte</title>
            <div className="flex-row mb-4">
               <div className="flex-row" style={{ flexWrap: "wrap" }}>
                  {userObjects &&
                     availableUsers &&
                     Object.keys(availableUsers).map((item, index) => {                        
                        return(
                        <Button
                           style={{
                              margin: 4,
                              border: "none",
                              /* borderRadius: "0", */
                              ...(availableUsers[item]
                                 ? {
                                      backgroundColor: userObjects[item].color,
                                   }
                                 : { backgroundColor: "#fff", color: "#000" }),
                           }}
                           onClick={() => setAvailableUsers((prev) => ({ ...prev, [item]: !prev[item] }))}
                           className=""
                           variant="outline-light"
                        >
                           {userObjects[item].Name}
                        </Button>
                     )})}
               </div>
            </div>

            <div className="flex-row">
               <div className=" flex-col w-50 me-5">
                  <h2 className="text-center mb-3">
                     Gesamtzeitspanne:
                  </h2>
                  <div className="flex-row mb-5">
                     <span className="me-2">
                        <DatePicker
                           selected={startDatum}
                           showTimeCaption={false}
                           dateFormat="dd.MM.yyyy"
                           onChange={(date) => {
                              setStartDatum(date);
                           }}
                           locale="de"
                           className="custom-date-inputfield"
                           calendarClassName="custom-date-calendar"
                           placeholderText=""
                        />
                     </span>
                     <span style={{ lineHeight: "40px", verticalAlign: "bottom" }}>bis</span>
                     <span className="mx-2">
                        <DatePicker
                           selected={endDatum}
                           showTimeCaption={false}
                           dateFormat="dd.MM.yyyy"
                           onChange={(date) => {
                              setEndDatum(date);
                           }}
                           locale="de"
                           className="custom-date-inputfield"
                           calendarClassName="custom-date-calendar"
                           placeholderText=""
                        />
                     </span>
                     <Button variant="dark" className="me-5" onClick={() => getEinkaufstermine()}>
                        →
                     </Button>
                     <Button
                        className="me-1"
                        variant={alleFilter ? "outline-dark" : "dark"}
                        onClick={() => {
                           setAvailableUsers((prev) =>
                              Object.keys(prev).reduce((oldObj, item) => ({ ...oldObj, [item]: !alleFilter }), {})
                           );
                           setAlleFilter((prev) => !prev);
                        }}
                     >
                        Alle Leute anzeigen/ausblenden
                     </Button>
                     <Button
                        className="me-5"
                        variant={"dark"}
                        onClick={() => {
                           setShowAlleTage((prev) => !prev);
                        }}
                     >
                        {!showAlleTage ? "Alle Tage anzeigen" : "Einen Tag anzeigen"}
                     </Button>
                  </div>

                  <h2 className="text-center mb-4">
                     Tagauswahl:
                     <strong>
                        {" "}
                        {new Intl.DateTimeFormat("de-DE", { weekday: "long" }).format(calenderday)}{" "}
                        {calenderday.toLocaleDateString()}
                     </strong>
                  </h2>
                  <div className="flex-row mb-5">
                     <Button
                        variant="dark"
                        className="me-1"
                        onClick={() => {
                           setCalenderday((prev) => new Date(prev.getTime() - 3600000 * 24));
                        }}
                     >
                        ←
                     </Button>
                     <span className="mx-2">
                        <DatePicker
                           selected={calenderday}
                           showTimeCaption={false}
                           dateFormat="dd.MM.yyyy"
                           onChange={(date) => {
                              setEndDatum(date);
                           }}
                           locale="de"
                           className="custom-date-inputfield"
                           calendarClassName="custom-date-calendar"
                           placeholderText=""
                        />
                     </span>
                     <Button
                        variant="dark"
                        className="ms-1"
                        onClick={() => {
                           setCalenderday((prev) => new Date(prev.getTime() + 3600000 * 24));
                        }}
                     >
                        →
                     </Button>
                  </div>
                  <div className="calender-frame">
                     <div className="calender-column">
                        {calenderInterval.map((hourItem) => (
                           <div className="time-row"> {hourItem}</div>
                        ))}
                     </div>

                     {availableUsers &&
                        Object.keys(availableUsers)
                           .filter((item) => availableUsers[item])
                           .map((item) => {
                              return (
                                 <div className="calender-column">
                                    <div className="user-row">{userObjects[item].Kuerzel}</div>
                                    {dayTermine2[item] &&
                                       dayTermine2[item].map((terminItem) => {
                                          const startTime = new Date(terminItem.date.start);
                                          const endTime = new Date(terminItem.date.end);
                                          const myheight = (endTime - startTime) / 60000;
                                          const myTop =
                                             startTime.getHours() * 60 +
                                             new Date(terminItem.date.start).getMinutes() -
                                             6 * 60;

                                          return (
                                             <div
                                                onClick={() => {
                                                   console.log(terminItem);

                                                   setSelectedTermin(terminItem.terminId);
                                                }}
                                                title={terminItem.type.label + " | " + terminItem.subject}
                                                className="appointment-row"
                                                style={{
                                                   height: myheight,
                                                   top: myTop,
                                                   backgroundColor:
                                                      selectedTermin === terminItem.terminId ? "#224" : "",
                                                   border:
                                                      terminItem.location && terminItem.location.type
                                                         ? ""
                                                         : "solid 8px #f00",
                                                }}
                                             >
                                                <span>
                                                   {terminArten[terminItem.type.label] &&
                                                      terminArten[terminItem.type.label].kuerzel}
                                                </span>
                                             </div>
                                          );
                                       })}
                                 </div>
                              );
                           })}
                  </div>

                  {selectedTermin && (
                     <div className="flex-row mt-3">
                        {alleTermine
                           .filter((item) => selectedTermin == item.terminId)
                           .map((item) => {
                              console.log(item);

                              return (
                                 <div
                                    style={{
                                       backgroundColor: "#224",
                                       color: "#fff",
                                       padding: "20px 40px",
                                       borderRadius: "10px",
                                    }}
                                 >
                                    <h4> {item.elements.type.label}</h4>
                                    <p>
                                       {new Date(item.elements.date.start).toLocaleString().slice(0, -3)} -{" "}
                                       {new Date(item.elements.date.end).toLocaleTimeString().slice(0, -3)}
                                    </p>
                                    <p>{item.elements.subject}</p>
                                    <p>{item.elements.users[0].userName}</p>
                                    {item.elements.estate && (
                                       <a
                                          className="btn btn-primary"
                                          href={"/datenblatt?estateid=" + item.elements.estate.id}
                                       >
                                          zum Objekt ↗{" "}
                                       </a>
                                    )}
                                 </div>
                              );
                           })}
                     </div>
                  )}
               </div>
               <div className=" flex-col w-50">
                  <Karte
                     terminInfos={einkaufstermine}
                     availableUsers={availableUsers}
                     userObjects={userObjects}
                     calenderday={calenderday}
                     showAlleTage={showAlleTage}
                     setSelectedTermin={setSelectedTermin}
                     selectedTermin={selectedTermin}
                     terminArten={terminArten}
                  />
               </div>
            </div>
         </div>
      </>
   );
}
